var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"100%"}},[_c('line',{attrs:{"x1":_vm.point1.x,"y1":_vm.point1.y,"x2":_vm.point2.x,"y2":_vm.point2.y,"stroke":"white","stroke-width":"2"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03556b56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/console/components/DynamicLine.vue
// module id = null
// module chunks = 